/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ files: NonNullable<unknown> }} Letterpreviewsourcedfromoneevent5Inputs */

const en_letterpreviewsourcedfromoneevent5 = /** @type {(inputs: Letterpreviewsourcedfromoneevent5Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Drafted from 1 timeline event you confirmed and ${i?.files} uploaded documents.`)
};

const pt_letterpreviewsourcedfromoneevent5 = /** @type {(inputs: Letterpreviewsourcedfromoneevent5Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Redigida a partir de 1 evento da cronologia que confirmou e ${i?.files} documentos carregados.`)
};

/**
* | output |
* | --- |
* | "Drafted from 1 timeline event you confirmed and {files} uploaded documents." |
*
* @param {Letterpreviewsourcedfromoneevent5Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const letterpreviewsourcedfromoneevent5 = /** @type {((inputs: Letterpreviewsourcedfromoneevent5Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Letterpreviewsourcedfromoneevent5Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_letterpreviewsourcedfromoneevent5(inputs)
	return pt_letterpreviewsourcedfromoneevent5(inputs)
});
export { letterpreviewsourcedfromoneevent5 as "letterPreviewSourcedFromOneEvent" }